import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService } from '../../../services/config/config.service';
import { CotizacionService } from '../../../services/cotizacion/cotizacion.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ReportesService } from '../../../services/reportes/reportes.service';

@Component({
  selector: 'app-listado-cotizacion',
  templateUrl: './listado-cotizacion.component.html',
  styleUrl: './listado-cotizacion.component.scss',
  standalone: false,
  providers: [MessageService]
})

export class ListadoCotizacionComponent implements OnInit {
  load: boolean = false;
  loadMenu: boolean = true;
  rangeDates: Date[] = [new Date(new Date().setDate(1)), new Date()];
  @ViewChild('calendar') calendar: any;
  token: any = {};
  infoUser: Array<any> = [];
  lsCotizacion: Array<any> = [];
  lsCotizacionFilter: Array<any> = [];
  txtFiltro: string = "";
  statesQuotation: Array<any> = [{ id: 1, name: 'En Proceso' }, { id: 2, name: "Finalizado" }];
  selectedStateQuotation: any = { id: 1, name: 'En Proceso' };
  lsStatesQuotation: Array<any> = [];
  displayForwardEmail: boolean = false;
  txtforwardEmail: string = "";
  rowSelected: any = {};

  constructor(private config: ConfigService,
    private cotizacion: CotizacionService,
    private router: Router,
    private reporte: ReportesService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");

    //obtener estados de la cotización
    this.cotizacion.getListStatesQuotation(this.token.token).subscribe({
      next: (response) => {
        this.lsStatesQuotation = response as Array<any>;
      },
      error: (error: HttpErrorResponse) => { if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); } }
    })
    this.getInfo();

    // saber si hay algunas pendientes cotizaciones por cierre
    /* this.cotizacion.getCotizacionesNoTracked(this.token.token).subscribe({
      next: (response) => { console.log(response) },
      error: (error: HttpErrorResponse) => { console.log(error) }
    }) */

  }


  onSelectDate = ($event: any) => {
    if (!!this.rangeDates[1]) {
      this.calendar.toggle();
      this.getInfo();
    }
  }

  getInfo = () => {
    this.load = true;
    //obtener información de las cotizaciones realizadas y en curso
    let serviceWEB: any | undefined;
    if (this.selectedStateQuotation.id == 1)
      serviceWEB = this.cotizacion.getCotizacionesInProcess(this.token.token, this.config.formatDateUnique(this.rangeDates[0]),
        this.config.formatDateUnique(this.rangeDates[1]));
    else
      serviceWEB = this.cotizacion.getCotizacionesCompleted(this.token.token, this.config.formatDateUnique(this.rangeDates[0]),
        this.config.formatDateUnique(this.rangeDates[1]))

    serviceWEB.subscribe({
      next: (response: Array<any>) => {
        this.lsCotizacion = response as Array<any>;
        this.lsCotizacionFilter = this.lsCotizacion;
        this.load = false;
      }, error: (error: HttpErrorResponse) => {
        if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); }
        this.load = false;
      }
    })
  }

  filterInfo = () => {
    this.lsCotizacionFilter = this.lsCotizacion.filter((row: any) => {
      return row.idCotizacion == this.txtFiltro || (row.idClienteNavigation.razonSocial != '' ? row.idClienteNavigation.razonSocial :
        row.idClienteNavigation.nombres).toLowerCase().indexOf(this.txtFiltro.toLowerCase()) > -1
    })
  }

  setTrackingQuotation = (row: any) => {
    const data = row.idEstadoSeguimientoCotizacionNavigation;
    this.cotizacion.setTrackingCotizacion(this.token.token, data, row.idCotizacion).subscribe({
      next: (response) => {
        row.message = '<div class="p-message p-message-success p-3 m-1">' + response + '</div>';
        this.load = false;
      }, error: (error: HttpErrorResponse) => {
        row.message = '<div class="p-message p-message-error p-3 m-1">' + error.message + '</div>';
        this.load = false;
        if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); }
      }
    })
  }



  forwardEmail = (email: string, row: any) => {
    this.cotizacion.setReenviarCotizacion(this.token.token, email, row.idCotizacion).subscribe({
      next: (response) => { row.message = '<div class="p-message p-message-success p-3 m-1">' + response as string + '</div>'; },
      error: (error: HttpErrorResponse) => {
        if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); }
      }
    })
  }

  stringToArray = (string: string, separator: string): Array<any> => {
    if ((string ?? '') != '')
      return string.split(separator);
    else
      return []
  }

  toSeeDetail = (id: number) => {
    //DetalleCotizacion
    this.router.navigate(['cotizacion/detalle_cotizacion', id])
    //window.open(url.toString(), '_blank')
  }

  toSeeDisplayForward = (row: any) => {
    this.rowSelected = row;
    this.displayForwardEmail = true;
    this.txtforwardEmail = "";
  }


  getReportQuotation = (row: any) => {
    this.load = true;
    this.reporte.getPDFCotizacion(row.idCotizacion ?? 0, 'pdf').subscribe({
      next: (response) => {
        const urlDownload = this.config.urlService.toString() + (response as String);
        window.open(urlDownload, "_blank");
        this.load = false;
      }, error: (error: HttpErrorResponse) => {
        this.load = false;
        this.config.handleError(error);
        row.message = '<div class="p-message p-message-info">Se ha presentado un error, favor intente de nuevo</div>';
      }
    })
  }
}
